import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

export const DragEffectContext = React.createContext();

function isModifierKeyPressed(event) {
  return !!(event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
}

let updateDragEffect = null;

function HTML5BackendWithModifierKeys(manager, context) {
  const result = HTML5Backend(manager, context);

  let altKeyPressed = false;
  Object.defineProperty(result, 'altKeyPressed', {
    set: () => {},
    get: () => altKeyPressed,
  });

  result.handleTopDragEnter_ = result.handleTopDragEnter;
  result.handleTopDragEnter = (e) => {
    if (isModifierKeyPressed(e) !== altKeyPressed) {
      altKeyPressed = !altKeyPressed;
      updateDragEffect?.(altKeyPressed);
    }
    result.handleTopDragEnter_(e);
  };

  result.handleTopDragOver_ = result.handleTopDragOver;
  result.handleTopDragOver = (e) => {
    if (isModifierKeyPressed(e) !== altKeyPressed) {
      altKeyPressed = !altKeyPressed;
      updateDragEffect?.(altKeyPressed);
    }
    result.handleTopDragOver_(e);
  };

  return result;
}

export function DndProviderWrapper({ children }) {
  const [dragEffect, setDragEffect] = React.useState(false);

  React.useEffect(() => {
    updateDragEffect = setDragEffect;
    return () => updateDragEffect = null;
  }, []);

  return (
    <DragEffectContext.Provider value={dragEffect}>
      <DndProvider backend={HTML5BackendWithModifierKeys}>{children}</DndProvider>
    </DragEffectContext.Provider>
  );
}
